import { render, staticRenderFns } from "./sharePoster.vue?vue&type=template&id=007d87c2&scoped=true"
import script from "./sharePoster.vue?vue&type=script&lang=js"
export * from "./sharePoster.vue?vue&type=script&lang=js"
import style0 from "./sharePoster.vue?vue&type=style&index=0&id=007d87c2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "007d87c2",
  null
  
)

export default component.exports